import { LegalPage } from "@/components/landing/LegalPage";

const sections = [
  {
    id: "agreement",
    title: "Agreement",
    body: (
      <p>
        By accessing or using Clinic OS, you agree to these Terms of Service on behalf of yourself and your clinic. If you don&apos;t agree, please don&apos;t use the service. These terms form a binding contract between you and <strong>ClinicFirst Inc.</strong>
      </p>
    ),
  },
  {
    id: "subscription",
    title: "Subscription &amp; billing",
    body: (
      <>
        <p>Clinic OS is sold as a monthly subscription, starting at $297/month per clinic location.</p>
        <ul>
          <li>Subscriptions auto-renew monthly unless cancelled before the renewal date.</li>
          <li>Plans can be upgraded or downgraded any time — prorated to the day.</li>
          <li>Annual plans are available with a discount; details from your account manager.</li>
          <li>All amounts are quoted in CAD unless otherwise stated. Taxes are added at checkout.</li>
        </ul>
      </>
    ),
  },
  {
    id: "acceptable-use",
    title: "Acceptable use",
    body: (
      <>
        <p>You agree to use Clinic OS lawfully and responsibly. You will not:</p>
        <ul>
          <li>Send unsolicited marketing or violate anti-spam laws (CASL, TCPA, etc.) through Clinic OS.</li>
          <li>Upload malware, attempt to reverse-engineer the service, or test its security without written consent.</li>
          <li>Use the AI modules to generate clinical advice that bypasses qualified clinician review.</li>
          <li>Resell or sublicense Clinic OS without a written reseller agreement.</li>
        </ul>
      </>
    ),
  },
  {
    id: "your-data",
    title: "Your data",
    body: (
      <p>
        Your clinic&apos;s data — including patient records read from your EMR — remains yours. We are a processor; you are the controller. We never sell or share your data for advertising. Export it at any time. See the <strong>Privacy Policy</strong> for details.
      </p>
    ),
  },
  {
    id: "uptime",
    title: "Uptime & SLA",
    body: (
      <p>
        We target <strong>99.9% monthly uptime</strong> for the core platform. Status and historical incidents are published on our Status page. SLA credits are available on enterprise plans and detailed in your order form.
      </p>
    ),
  },
  {
    id: "termination",
    title: "Cancellation & termination",
    body: (
      <>
        <p>Either party can terminate at any time:</p>
        <ul>
          <li><strong>You</strong> can cancel inside Settings. Service runs through the end of the paid period.</li>
          <li><strong>We</strong> may suspend or terminate for unpaid invoices or material breach of these terms, with reasonable notice.</li>
          <li>On termination, you have 30 days to export your data. After that, operational data is deleted on schedule.</li>
        </ul>
      </>
    ),
  },
  {
    id: "liability",
    title: "Liability",
    body: (
      <p>
        Clinic OS is provided &ldquo;as is&rdquo;. Our liability is limited to the fees you paid us in the 12 months preceding the claim. We are not liable for indirect, incidental, or consequential damages. Nothing here limits liability that cannot be limited by law.
      </p>
    ),
  },
  {
    id: "governing-law",
    title: "Governing law",
    body: (
      <p>
        These terms are governed by the laws of the Province of Ontario, Canada. Disputes are resolved in the courts of Ottawa, Ontario.
      </p>
    ),
  },
];

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      kicker="Legal · terms of service"
      title="The rules of"
      highlight="the road."
      subtitle="Plain-language terms for using Clinic OS. Short, fair, written to be read."
      updated="Feb 2026"
      sections={sections}
    />
  );
}
